// Auto-generated from Legal/*.docx — do not edit by hand. Run: node scripts/extract-legal-docs.mjs
export const LEGAL_EFFECTIVE_DATE = '18 May 2026';

export const LEGAL_DOC_FILES = {
  "privacy": "PRIVACY_POLICY_FINAL_V_1.0.docx",
  "terms": "TERMS_AND_CONDITIONS_FINAL_V_1.0.docx",
  "cookies": "COOKIES_POLICY.docx",
  "dpa": "DATA_PROCESSING_AGREEMENT_FINAL_V_1.0.docx"
};

export const LEGAL_DOCUMENTS = [
  {
    "id": "privacy",
    "title": "Privacy Policy",
    "shortTitle": "Privacy",
    "effectiveDate": "18 May 2026"
  },
  {
    "id": "terms",
    "title": "Terms and Conditions",
    "shortTitle": "Terms",
    "effectiveDate": "18 May 2026"
  },
  {
    "id": "cookies",
    "title": "Cookies Policy",
    "shortTitle": "Cookies",
    "effectiveDate": "18 May 2026"
  },
  {
    "id": "dpa",
    "title": "Data Processing Agreement",
    "shortTitle": "DPA",
    "effectiveDate": "18 May 2026"
  }
];

export const LEGAL_DOCUMENT_BY_ID = Object.fromEntries(LEGAL_DOCUMENTS.map((doc) => [doc.id, doc]));
